export const RegularDateFormat = 'MMM d, yyyy | HH:mm:ss';
export const RegularDateFormatMMMdyyyy = 'MMM d, yyyy';
